import styled from 'styled-components';
import { theme } from './theme/globalStyle';

const Application = styled.div`
  background-color: ${theme.bg};
  /* background-image: url(https://source.unsplash.com/collection/1976082); */
  background-size: cover;
  background-position: center;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  min-height: 535px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Application
